import { AppState } from '../../bootstrap/redux/state/AppState';
import { ISiteNameSansId } from '../serverApi/types/ISiteNameSansId';


export function selectSites(state: AppState): ReadonlyArray<ISiteNameSansId> {
  return state.sites;
}
